import React from "react";
import { Spinner } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import ImageUploader from "../../Components/ImageUploader";
import Keywords from "../../Components/Keywords";
import Loading from "../../Components/Loading";
import Region from "../../Components/Region";
import { useSingle } from "./Hooks";

const Edit = () => {
  const { navigate, form, setForm, loading, user, handler, value, publishHandler } =
    useSingle();
  if (loading.show) {
    return (
      <>
        <header className="d-flex justify-content-between">
          <div className="d-flex  align-items-center">
            <button
              className="btn"
              onClick={() => {
                navigate(-1);
              }}
            >
              <BsArrowRight />
            </button>
            <p className="fs-12 m-0">ویرایش آگهی</p>
          </div>
        </header>
        <div className="container">
          <div className="row">
            <Loading />
          </div>
        </div>
      </>
    );
  }
  return (
    <div>
      <header className="d-flex justify-content-between">
        <div className="d-flex  align-items-center">
          <button
            className="btn"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowRight />
          </button>
          <p className="fs-12 m-0">ویرایش آگهی</p>
        </div>
      </header>
      <div className="container mt-3">
        <div className="row">
          <div className="col-12">
            <form>
              <div className="form-group">
                <label htmlFor="title">عنوان آگهی</label>
                <input
                  type="text"
                  className="form-control"
                  id="title"
                  aria-describedby="titleHelp"
                  placeholder="عنوان آگهی خود را وارد نمایید(200 کاراکتر)"
                  onChange={({ target: { value } }) => {
                    handler("title", value);
                  }}
                  value={value("title")}
                />
                <small id="titleHelp" className="form-text text-muted">
                  در عنوان بهتر است از ویژگی های متمایز نام برده شود
                </small>
              </div>
              <div className="form-group">
                <label htmlFor="description">توضیحات</label>
                <textarea
                  type="text"
                  className="form-control"
                  id="description"
                  aria-describedby="descriptionHelp"
                  rows={10}
                  placeholder="توضیحات محصول را اینجا وارد نمایید"
                  onChange={({ target: { value } }) => {
                    handler("description", value);
                  }}
                  value={value("description")}
                />
                <small id="descriptionHelp" className="form-text text-muted">
                  توضیحات راجع به محصول موردنظر
                </small>
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="first-name">
                  نوع آگهی
                </label>
                <select
                  className="form-control"
                  id="type"
                  type="text"
                  onChange={({ target: { value } }) => {
                    handler("model", value);
                  }}
                  aria-describedby="typeHelp"
                  value={value("model")}
                >
                  <option>انتخاب کنید</option>
                  <option value={"sale"}>فروش</option>
                  <option value={"request"}>درخواست</option>
                  <option value={"rent"}>اجاره</option>
                  <option value={"introduction"}>معرفی</option>
                  <option value={"buy"}>خرید</option>
                  <option value={"other"}>سایر</option>
                </select>
                <small id="typeHelp" className="form-text text-muted">
                  توضیحات راجع به محصول موردنظر
                </small>
              </div>
            </form>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Region set={handler} value={value} />
          </div>
          <div className="col-12">
            <label className="form-label" htmlFor="first-name">
              آدرس
            </label>

            <input
              className="form-control"
              id="first-name"
              type="text"
              placeholder="آدرس آگهی را وارد نمایید"
              onChange={({ target: { value } }) => {
                handler("addres", value);
              }}
              value={value("addres")}
            />
            <small className="fs-10">آدرس مورد نظر را دقیق وارد کنید</small>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12">
            <ImageUploader
              element={{
                key: "main_image",
                label: "عکس اصلی",
                subLabel: "عکس شاخص محصول خود را بارگذای نمایید",
              }}
              form={form}
              setForm={setForm}
              single={true}
            />
            <ImageUploader
              element={{
                key: "product_images",
                label: "عکس های محصول",
                subLabel: "می توانید چندین عکس را بارگذاری نمایید",
              }}
              form={form}
              setForm={setForm}
              single={false}
            />
            <Keywords
              form={form}
              setForm={setForm}
              options={{
                title: "کلمات کلیدی",
                key: "keywords",
              }}
            />
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 ">
            <div className="mb-2">
              <label>نوع شخص آگهی دهنده</label>
              <p className="fs-10 mb-1">مشخص کردن نوع شخص آگهی دهنده</p>
              <div className="d-flex align-items-center">
                <div className="check-box-wrapper">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDisabled"
                    id="flexRadioDisabled"
                    onClick={() => {
                      setForm({ ...form, type: "personal" });
                    }}
                    checked={form.type == "personal"}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDisabled"
                  >
                    شخصی
                  </label>
                </div>
                <div className="check-box-wrapper">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDisabled"
                    id="flexRadioCheckedDisabled"
                    onClick={() => {
                      setForm({ ...form, type: "company" });
                    }}
                    checked={form.type == "company"}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioCheckedDisabled"
                  >
                    شرکتی
                  </label>
                </div>
              </div>
            </div>
            <div>
              {form.type === "personal" ? (
                <>
                  <div className="col-12">
                    <label className="form-label" htmlFor="first-name">
                      نام و نام خانوادگی
                    </label>

                    <input
                      className="form-control"
                      id="first-name"
                      type="text"
                      placeholder="نام و نام خانوادگی خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("fullname", value);
                      }}
                      defaultValue={user?.user?.fullname}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="first-name">
                      موبایل
                    </label>

                    <input
                      className="form-control"
                      id="first-name"
                      type="number"
                      placeholder="موبایل خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("mobile", value);
                      }}
                      defaultValue={user?.user?.mobile}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="first-name">
                      ایمیل
                    </label>

                    <input
                      className="form-control"
                      id="first-name"
                      type="email"
                      placeholder="ایمیل خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("email", value);
                      }}
                      defaultValue={user?.user?.email}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="col-12">
                    <label className="form-label" htmlFor="first-name">
                      نام شرکت
                    </label>

                    <input
                      className="form-control"
                      id="first-name"
                      type="text"
                      placeholder="نام شرکت خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("fullname", value);
                      }}
                      value={value("fullname")}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="first-name">
                      تلفن شرکت
                    </label>

                    <input
                      className="form-control"
                      id="first-name"
                      type="number"
                      placeholder="تلفن شرکت خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("mobile", value);
                      }}
                      value={value("mobile")}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="first-name">
                      موبایل شرکت
                    </label>

                    <input
                      className="form-control"
                      id="first-name"
                      type="number"
                      placeholder="موبایل شرکت خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("mobile", value);
                      }}
                      value={value("mobile")}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="first-name">
                      آدرس شرکت
                    </label>

                    <input
                      className="form-control"
                      id="first-name"
                      type="email"
                      placeholder="آدرس شرکت خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("email", value);
                      }}
                      value={value("email")}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="first-name">
                      آدرس وب سایت
                    </label>

                    <input
                      className="form-control"
                      id="first-name"
                      type="email"
                      placeholder="آدرس وب سایت شرکت خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("email", value);
                      }}
                      value={value("email")}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="col-12">
              <label className="form-label" htmlFor="first-name">
                قیمت آگهی (تومان)
              </label>

              <input
                className="form-control"
                id="first-name"
                type="number"
                placeholder=" قیمت را وارد کنید"
                onChange={({ target: { value } }) => {
                  handler("price", value);
                }}
                value={value("price")}
              />
            </div>
          </div>
        </div>
        <div className="row justify-content-end mt-2">
          <div className="col d-flex justify-content-end mb-3 mt-3">
            {/* <button className="btn btn-primary " onClick={() => {}}>
              {loading.edit ? (
                <>
                  <Spinner size="sm" />{" "}
                </>
              ) : (
                "ویرایش آگهی"
              )}
            </button> */}
            <button className="btn btn-primary " onClick={publishHandler}>
              {loading.submit ? (
                <>
                  <Spinner size="sm" />{" "}
                </>
              ) : (
                "انتشار آگهی"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
